import React, {useEffect, useState} from 'react';
import {capitalizeFirstLetters, formatAccount} from "../../features/ValueFormater";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPenToSquare} from "@fortawesome/free-solid-svg-icons";
import {useDispatch} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useOutletContext} from "react-router-dom";

const LimitsView = ({setLimits , setValidLimits}) => {

    const [superadminUSD, setSuperadminUSD] = useState({
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        LimitPerYear: 0
    });

    const [superadminLBP, setSuperadminLBP] = useState({
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        LimitPerYear: 0
    });

    const [adminUSD, setAdminUSD] = useState({
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        LimitPerYear: 0
    });

    const [adminLBP, setAdminLBP] = useState({
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        LimitPerYear: 0
    });

    const [errorMessage, setErrorMessage] = useState('');


    const validForm = () => {
        const objectsToValidate = [superadminUSD, superadminLBP, adminUSD, adminLBP];

        for (const obj of objectsToValidate) {
            const keys = Object.keys(obj);
            for (const key of keys) {
                if (obj[key] <= 0 || obj[key] === null) {
                    setErrorMessage('Limits Should be greater than 0');
                    return false;
                }
            }
        }

        setErrorMessage('');
        return true;
    };

    const handleSave = () => {
        if (validForm()) {
            setValidLimits(true);
            setLimits({
                EmployeeLimitSuperAdminUSD: superadminUSD,
                EmployeeLimitSuperAdminLBP: superadminLBP,
                EmployeeLimitAdminUSD: adminUSD,
                EmployeeLimitAdminLBP: adminLBP
            });
        }else{
            setValidLimits(false);
        }
    }

    useEffect(() => {
        handleSave();
    }, [superadminUSD, superadminLBP, adminUSD, adminLBP]);

    return (
        <div className="employee-limits">
            <div className="title">EMPLOYEE LIMITS PER ACCESS LEVEL</div>
            {errorMessage && <span className="error">{errorMessage}</span>}

            <div className="my-4 limits-container">
                <div className="subtitle mb-3">
                    SUPER ADMIN TRANSACTIONS LIMITS
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="label">Limit Per Transaction in USD</div>
                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setSuperadminUSD({
                                               ...superadminUSD,
                                               LimitPerTransaction: Number(e.target.value)
                                           });
                                   }}
                            />
                            <div className="currency">$</div>
                        </div>

                        <div className="label">Limit Per Month in USD</div>
                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setSuperadminUSD({
                                               ...superadminUSD,
                                               LimitPerMonth: Number(e.target.value)
                                           });
                                   }}
                            />
                            <div className="currency">$</div>
                        </div>

                        <div className="label">Limit Per Year in USD</div>
                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setSuperadminUSD({
                                               ...superadminUSD,
                                               LimitPerYear: Number(e.target.value)
                                           });
                                   }}
                            />
                            <div className="currency">$</div>
                        </div>
                    </div>


                    <div className="col-md-6">
                        <div className="label">Limit Per Transaction in LBP</div>

                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setSuperadminLBP({
                                               ...superadminLBP,
                                               LimitPerTransaction: Number(e.target.value)
                                           });
                                   }
                                   }
                            />
                            <div className="currency">L.L</div>
                        </div>
                        <div className="label">Limit Per Month in LBP</div>

                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setSuperadminLBP({
                                               ...superadminLBP,
                                               LimitPerMonth: Number(e.target.value)
                                           });
                                   }}
                            />
                            <div className="currency">L.L</div>
                        </div>

                        <div className="label">Limit Per Year in LBP</div>
                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setSuperadminLBP({
                                               ...superadminLBP,
                                               LimitPerYear: Number(e.target.value)
                                           });
                                   }}
                            />
                            <div className="currency">L.L</div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="my-4 limits-container">
                <div className="subtitle mb-3">
                    ADMIN TRANSACTIONS LIMITS
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="label">Limit Per Transaction in USD</div>
                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setAdminUSD({
                                               ...adminUSD,
                                               LimitPerTransaction: Number(e.target.value)
                                           });
                                   }}
                            />
                            <div className="currency">$</div>
                        </div>
                        <div className="label">Limit Per Month in USD</div>

                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setAdminUSD({
                                               ...adminUSD,
                                               LimitPerMonth: Number(e.target.value)
                                           });
                                       }
                                   }
                            />
                            <div className="currency">$</div>
                        </div>

                        <div className="label">Limit Per Year in USD</div>

                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setAdminUSD({
                                               ...adminUSD,
                                               LimitPerYear: Number(e.target.value)
                                           });
                                   }}
                            />
                            <div className="currency">$</div>
                        </div>
                    </div>


                    <div className="col-md-6">
                        <div className="label">Limit Per Transaction in LBP</div>

                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setAdminLBP({
                                               ...adminLBP,
                                               LimitPerTransaction: Number(e.target.value)
                                           });
                                   }}
                            />
                            <div className="currency">L.L</div>
                        </div>

                        <div className="label">Limit Per Month in LBP</div>

                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setAdminLBP({
                                               ...adminLBP,
                                               LimitPerMonth: Number(e.target.value)
                                           });
                                       }
                                   }
                            />
                            <div className="currency">L.L</div>
                        </div>


                        <div className="label">Limit Per Year in LBP</div>
                        <div className="input-group">
                            <input type="text"
                                   onChange={(e) => {
                                           setAdminLBP({
                                               ...adminLBP,
                                               LimitPerYear: Number(e.target.value)
                                           });
                                       }
                                   }
                            />
                            <div className="currency">L.L</div>
                        </div>
                    </div>
                </div>
            </div>

            {/*<div className="text-center">*/}
            {/*    <button className="save-btn" onClick={handleSave}>Save</button>*/}
            {/*</div>*/}
        </div>
    );
};

export default LimitsView;